import { AppHost } from "../app";
import { HostStore } from "../host";

export class AppHostStore extends HostStore<AppHost> {}
